import React from 'react';
import { useTranslations } from 'next-intl';
import { FAQSection } from 'components/shared/FAQSection';
import { getPerformanceLabFaqData } from './performanceLabFaqData';
import styles from './FaqSection.module.css';

type FaqSectionProps = {
  faqData?: {
    title: string | React.ReactNode;
    description: React.ReactNode;
  }[];
  heading?: React.ReactNode;
  htmlId?: string;
  ariaLabel?: string;
  bgColor?: 'white' | 'black' | 'grey';
};

export const FaqSection: React.FC<FaqSectionProps> = ({
  faqData,
  heading,
  htmlId = 'performance-lab-faq',
  ariaLabel,
  bgColor = 'black',
}) => {
  const t = useTranslations('performance-lab');

  return (
    <FAQSection
      className={styles.styledFaqSection}
      faqData={faqData ?? getPerformanceLabFaqData(t)}
      bgColor={bgColor}
      htmlId={htmlId}
      heading={heading ?? t('faq.head')}
      aria-label={ariaLabel ?? t('faq.aria')}
    />
  );
};
